import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CardBrandIcon from '../../../Shared/CardBrandIcon';
import PaymentStatusBadge from '../../../Shared/PaymentStatusBadge';
import {  formatDateTime, formatAmount } from '../../../../Common/utils';

const Menu = ({ orderId }) => (
    <div className="dropdown">
        <a className="btn btn-sm btn-icon-only text-light"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <i className="fas fa-ellipsis-v" />
        </a>
        <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
            <Link className="dropdown-item" to={`/pedidos/${orderId}`}>Venda</Link>
            {/* <Link className="dropdown-item" to={`/pagamentos/${id}`}>Detalhes</Link> */}
            {/* <Link className="dropdown-item" to={`/pagamentos/comprovante/${id}`}>Comprovante</Link> */}
        </div>
    </div>
);

export default class TableRow extends Component {
    render() {
        const { order, nsu, createdAt, card, amount, paymentType, installments, installmentsAmount, paymentStatus, id } = this.props;
        return (
            <tr>
                <th scope="row">
                    {order ? (
                        <Link to={`/vendas/${order.portalOrder.id}`}>{order.protocol}</Link>
                    ) : 'Não tem'}
                </th>
                <td>{nsu}</td>
                <td>{formatDateTime(createdAt)}</td>
                <td>
                    {!!card && (<CardBrandIcon brand={card.brand} />)}
                </td>
                <td>{!!card ? card.trunc : ''}</td>
                <td>{paymentType}</td>
                <td>{formatAmount(amount)}</td>
                <td>{installments}x {formatAmount(installmentsAmount)}</td>
                <td>
                    <PaymentStatusBadge status={paymentStatus} />
                </td>
                <td className="text-right">
                    {/* <Menu orderId={portalOrder.id} id={id} /> */}
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/Table/TableRow.js